// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4afd8f6f","239":"40d23df7","455":"04e40de7"}[chunkId] + ".chunk.js";
};